<template>
  <div class="w-full flex justify-between pl-3">
    <div class="my-auto font-bold text-xl text-black ml-2">
      Request Examples <span class="font-light text-lg">({{examplesCount}})</span>
    </div>
    <base-button variant="primary-light"
                 icon="add"
                 icon-size="1.5rem"
                 data-cy="add-answer-example-button"
                 @click="updateMode(EXAMPLE_EDITOR_MODE.ADD)"
    >
      <span class="my-auto ml-1">Add</span>
    </base-button>
  </div>
</template>

<script>
import { EXAMPLE_EDITOR_MODE } from '@/store/constants'

export default {
  name: 'IntentExamplesHeaderDefault',
  props: {
    examplesCount: {
      type: Number
    }
  },
  data() {
    return {
      EXAMPLE_EDITOR_MODE
    }
  },
  methods: {
    updateMode(mode) {
      this.$emit('update-mode', mode)
    }
  }
}
</script>
